var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H9C8.6 1 8.3 1.2 8.1 1.6L7.4 3H1C0.4 3 0 3.4 0 4V7V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V2C16 1.4 15.6 1 15 1ZM8 5C8.4 5 8.7 4.8 8.9 4.4L9.6 3H14V6H2V5H8ZM2 14V8H14V14H2Z",
    fill: "#393B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.c70ba85622b305349b22b871e8fb4a80.svg";
export { ForwardRef as ReactComponent };